export default __webpack_public_path__ + "static/Answer, summarise, prioritise-de46d321e0b89c293c5c4bd70a312664.png";